import React from "react";

import HudMenuBox from "./HUD_menuBox";

import GraphicIconWrapper from "../UI/Graphic_IconWrapper";
import ClockSVG from "../../../../common/logos/TimerLogo";

export default function HUD({ itemsLeft, level, foundItems, timer, showWin }) {
  return (
    <div
      style={{
        pointerEvents: "none",
      }}
    >
      {showWin && (
        <div className="HUD">
          {/* <p>HUD</p> */}

          <div className="hud_child">
            <HudMenuBox>
              <div>
                <GraphicIconWrapper txt={foundItems} col={"lightgreen"} />
                <h2>found</h2>
              </div>
              <div>
                <GraphicIconWrapper txt={itemsLeft} col={"darkgrey"} />
                <h2>left</h2>
              </div>
            </HudMenuBox>
          </div>

          <div className="hud_child"></div>

          <div className="hud_child">
            <HudMenuBox>
              <div>
                <ClockSVG width={"50%"} height={"50%"} col={"grey"} />
                {/* <h2>timer</h2> */}
              </div>
              <div
                style={{
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <h1>{timer} sec</h1>
              </div>
            </HudMenuBox>
          </div>
        </div>
      )}
    </div>
  );
}
